import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { MENU_DATA, SidenavMenuRef, FsSidenavModule } from '@firestitch/sidenav';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AclPermission } from '@app/common';
import { Environment } from '@app/common/interfaces';
import { AclService } from '@app/core';
import { CreateComponent } from '@app/environment/modules/create/components/create';

import { EnvironmentSwitchComponent } from '../environment-switch/environment-switch.component';
import { FsAclModule } from '@firestitch/acl';


@Component({
    templateUrl: './environment-menu.component.html',
    styleUrls: ['./environment-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FsSidenavModule, FsAclModule],
})
export class EnvironmentMenuComponent implements OnDestroy {
  dialog = inject(MatDialog);
  router = inject(Router);
  menuRef = inject<SidenavMenuRef<EnvironmentMenuComponent>>(SidenavMenuRef);
  data = inject(MENU_DATA);


  public environments: Environment[] = [];
  public AclPermission = AclPermission;
  // Switch Organization lists the organizations the account belongs to, which the server
  // refuses to an account that belongs to none (an admin belongs to every one)
  public readonly canSwitchOrganization = inject(AclService).hasPermissionOrganization();

  private _destroy$ = new Subject<void>();

  constructor() {
    const data = this.data;

    this.environments = data.environments;
  }

  public close(): void {
    this.menuRef.close();
  }

  public create(): void {
    this.close();

    this.dialog.open(CreateComponent, {
      data: { autofocus: false },
    });
  }

  public switch(): void {
    this.close();
    this.dialog.open(EnvironmentSwitchComponent)
      .afterClosed()
      .pipe(
        filter((response) => !!response),
        takeUntil(this._destroy$),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
